module.exports = __webpack_public_path__ + "static/media/oizom.8f350f92.svg";